import styled from 'styled-components';
import { Colors } from 'basic-ui-lib/constants';
import { Text } from 'basic-ui-lib/components/Text';
import { IcChevronDown } from 'basic-ui-lib/icons';
import { Col } from 'basic-ui-lib';
import SelectPlaylistModal, {
  useSelectPlaylistModalRef,
} from '../SelectPlaylistModal';
import { useMemo } from 'react';
import useGetListPlaylists from 'modules/playlist/services/hooks/useGetListPlaylists';

interface PlaylistSelectorProps {
  value?: string;
  onChange?: (playlist: string) => void;
  currentStoreId?: string;
}

const PlaylistSelector = ({
  value,
  onChange,
  currentStoreId,
}: PlaylistSelectorProps) => {
  const modalRef = useSelectPlaylistModalRef();
  const [playlistsData] = useGetListPlaylists(true);

  const handleOpenModal = () => {
    modalRef.current?.show(value ?? '', (playlistId) => {
      onChange?.(playlistId);
    });
  };

  const selectedPlaylistName = useMemo(() => {
    const playlists = playlistsData?.content ?? [];

    return playlists.find((playlist) => playlist.id === value)?.name ?? '';
  }, [playlistsData, value]);

  return (
    <>
      <SelectorButton onClick={handleOpenModal} type='button'>
        <Col gap={0}>
          <LabelText>Playlist</LabelText>

          <TextWrapper>
            <Text body_1 medium color='neutral.text.5' left>
              {selectedPlaylistName || 'Select Playlist'}
            </Text>
          </TextWrapper>
        </Col>

        <IcChevronDown fill={Colors.primary[5]} width={16} height={16} />
      </SelectorButton>

      <SelectPlaylistModal ref={modalRef} currentStoreId={currentStoreId} />
    </>
  );
};

export default PlaylistSelector;

const SelectorButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  height: 49px;
  width: 100%;
  background: ${Colors.neutral.bg[1]};
  border: 1px solid ${Colors.neutral.border[1]};
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;

  &:hover {
    border-color: ${Colors.primary[5]};
  }

  &:focus {
    border-color: ${Colors.primary[5]};
    outline: none;
  }
`;

const TextWrapper = styled.div`
  flex: 1;
  min-width: 0;
  text-align: left;

  .custom-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media (max-width: 768px) {
    .body_1 {
      font-size: 12px;
    }
  }
`;

const LabelText = styled.span`
  font-family: 'Poppins';
  font-size: 11px;
  font-weight: 400;
  color: ${Colors.neutral.text[4]};
  z-index: 1;
  pointer-events: none;
  text-align: left;
`;
